// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__11eYr","errorLogs":"styles_errorLogs__294Ej"};